import React, { useEffect } from 'react';

import { useSearchContext } from '@atlas/core';

import { useSearch } from 'hooks/useSearch';

import { useSearchInputState } from './context/InputProvider';
import { useSimpleSearchState } from './context/SimpleProvider';
import EmptyState from './EmptyState';
import SearchError from './Error';
import Events from './Events';
import Loader from './Loader';
import SearchPrompt from './SearchPrompt';
import Tournaments from './Tournaments';

const SimpleSearchList = () => {
  const { empty, error, loading, resetSearchResults } = useSearchContext();
  const { isValidPrompt, searchString } = useSearch();
  const { focused } = useSearchInputState();
  const { isOpened } = useSimpleSearchState();

  useEffect(() => {
    if (isValidPrompt) return;
    resetSearchResults();
  }, [isValidPrompt, resetSearchResults]);

  if (!isOpened) return null;
  if (focused && !searchString) return null;
  if (!isValidPrompt) return <SearchPrompt />;
  if (error) return <SearchError />;
  if (loading) return <Loader />;
  if (empty) return <EmptyState />;

  return (
    <div className="simple-search-list">
      <Tournaments />
      <Events />
    </div>
  );
};

export default SimpleSearchList;
